/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomAttributeNoteOut
 */
export interface CustomAttributeNoteOut {
    /**
     * 
     * @type {string}
     * @memberof CustomAttributeNoteOut
     */
    offerId: string;
    /**
     * 
     * @type {string}
     * @memberof CustomAttributeNoteOut
     */
    note?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomAttributeNoteOut
     */
    attributeId: number;
    /**
     * 
     * @type {Date}
     * @memberof CustomAttributeNoteOut
     */
    modificationDate: Date;
}

export function CustomAttributeNoteOutFromJSON(json: any): CustomAttributeNoteOut {
    return CustomAttributeNoteOutFromJSONTyped(json, false);
}

export function CustomAttributeNoteOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomAttributeNoteOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'offerId': json['offerId'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'attributeId': json['attributeId'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function CustomAttributeNoteOutToJSON(value?: CustomAttributeNoteOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'offerId': value.offerId,
        'note': value.note,
        'attributeId': value.attributeId,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


